Mmg.addShortcode(
    'multi_profession_job_list',
    '.sc-multi-profession-job-list',

    /**
     * @param {Element} el        The shortcode's DOM element
     * @param {object}  model     Data from data-json
     * @param {jQuery}  $         jQuery
     * @param {string}  selector  The shortcode selector
     * @param {string}  className The shortcode block class
     */
    (el, model, $, selector, className) => {

        const $widget = $(el);
        const $groups = $widget.find(`.${className}__groups`);
        const $shownCount = $widget.find(`.${className}__shown-count`);
        const $totalCount = $widget.find(`.${className}__total-count`);
        const $loadMore = $widget.find(`.${className}__load-more`);
        const $sortSelect = $widget.find(`.${className}__sort-select`);
        const template = $widget.find(`.${className}__job-template`).html();
        const groupTemplate = $widget.find(`.${className}__group-template`).html();

        let activeRequest = null;
        let activeProfessionId = null;
        let activeSort = $sortSelect.val();
        let page = 1;
        let loadedJobs = [];
        let loadedCount = parseInt(model.initial_count) || 0;
        let totalCount = parseInt(model.job_count) || 0;

        (function init() {
            addEvents();
        })();


        /**
         * Bind all widget-level event listeners.
         */
        function addEvents() {
            $widget.on('click', `.${className}__profession-toggle`, onProfessionClick);
            $loadMore.on('click', onLoadMoreClick);
            $sortSelect.on('change', onSortChange);
        }


        /**
         * Handle sort dropdown change: reset to page 1 and re-fetch.
         */
        function onSortChange() {
            activeSort = $sortSelect.val();
            resetAndFetch();
        }


        /**
         * Handle profession button click: filter by profession, reset to page 1, re-fetch.
         */
        function onProfessionClick(event) {
            const $button = $(this);
            event.preventDefault();

            if ($button.hasClass('active')) {
                return;
            }

            $widget.find(`.${className}__profession-toggle`).removeClass('active');
            $button.addClass('active');
            activeProfessionId = $button.data('profession-id') || null;
            totalCount = activeProfessionId ? model.profession_counts[activeProfessionId] : parseInt(model.job_count) || 0;
            resetAndFetch();
        }


        /**
         * Handle Load More click: append the next page to loadedJobs and re-render all groups.
         * On the first click from SSR state (loadedJobs empty), re-fetches page 1 first so groups merge correctly.
         */
        function onLoadMoreClick(event) {
            event.preventDefault();

            if (!loadedJobs.length) {
                // SSR rendered page 1; fetch pages 1-2 together in one request to prime loadedJobs.
                page = 1;
                fetchPage(20);
                page = 2;
            } else {
                page++;
                fetchPage();
            }
        }


        /**
         * Reset state to page 1 and fetch fresh results (used by sort and profession filter changes).
         */
        function resetAndFetch() {
            loadedJobs = [];
            page = 1;
            fetchPage();
        }


        /**
         * Fire a GET request for the current page, append results to loadedJobs, and re-render.
         *
         * @param {number} [limit]  Jobs per page; defaults to 10 on the server. Pass 20 to fetch two pages in one request.
         */
        function fetchPage(limit) {
            const [sortField, sortDir] = activeSort.split(':');
            const params = {
                region_id: model.region_id,
                state_id: model.state_id,
                filters: {
                    profession_id: activeProfessionId,
                    facility_type: model.facility_type,
                },
                sort: sortField,
                sort_direction: sortDir,
                show_filters: false,
                page: page,
                limit: limit,
                max: limit,
            };

            if (activeRequest && activeRequest.readyState !== 4) {
                activeRequest.abort();
            }

            activeRequest = $.ajax({
                url: model.rest_url,
                method: 'GET',
                data: params,
            })
            .done(function(response) {
                const jobs = response.jobs;
                loadedJobs = loadedJobs.concat(jobs);
                loadedCount = loadedJobs.length;
                $groups.html(buildGroupsHtml());
                updateCountUI();
            });
        }


        /**
         * Re-render the full loadedJobs set into grouped HTML.
         *
         * @return {string}
         */
        function buildGroupsHtml() {
            const defaults = {
                region_name: model.region_name,
                show_profession_badge: true
            };

            return groupJobs(loadedJobs).map(function(group) {
                return renderGroup(group, defaults);
            }).join('');
        }


        /**
         * Render one group: derive intro, render jobs, then render the group template.
         *
         * @param {Array} group
         * @param {object} defaults
         * @return {string}
         */
        function renderGroup(group, defaults) {
            const exampleJob = group[0];
            const group_intro = model.region_level === 'state' || !!Number(exampleJob.is_in_region)
                ? `In ${model.region_name}`
                : `Nearby (Within ${model.state_name} + 150 MILES)`;
            const jobs = group.map(function(job) {
                return Mustache.render(template, $.extend({}, defaults, job));
            });
            return Mustache.render(groupTemplate, { group_intro, jobs });
        }


        /**
         * Update the count label and show/hide the Load More button.
         */
        function updateCountUI() {
            $shownCount.text(loadedCount);
            $totalCount.text(totalCount);

            const remaining = totalCount - loadedCount;
            if (remaining > 0) {
                $loadMore.text(`Load More (${Math.min(10, remaining)} of ${remaining} remaining)`);
                $loadMore.show();
            } else {
                $loadMore.hide();
            }
        }


        /**
         * Group jobs by model.group_parameter, preserving encounter order.
         *
         * @param {Array} jobs
         * @return {Array<Array>}
         */
        function groupJobs(jobs) {
            const map = {};
            const order = [];
            jobs.forEach(function(job) {
                const key = job[model.group_parameter];
                if (!map[key]) {
                    map[key] = [];
                    order.push(key);
                }
                map[key].push(job);
            });
            return order.map(function(key) {
                return map[key];
            });
        }


    }
);
